import { IMAGES } from "../data";

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-[#EFECE4]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="overline">Our Work</p>
            <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight leading-tight mt-4 text-[#1A2118]">
              Landscapes &amp; homes we've transformed
            </h2>
          </div>
          <a
            href="#contact"
            data-testid="gallery-cta"
            className="text-sm font-semibold text-[#1E3F20] border-b border-[#1E3F20] pb-1 hover:opacity-70 transition-opacity self-start"
          >
            Start your project →
          </a>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 mt-14 [&>*]:mb-5">
          {IMAGES.gallery.map((g, i) => (
            <figure
              key={i}
              data-testid="gallery-image-item"
              className="group relative overflow-hidden rounded-sm break-inside-avoid border border-[#D8D3C8]"
            >
              <img
                src={g.url}
                alt={g.title}
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                  i % 3 === 0 ? "h-80" : "h-64"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#13210F]/85 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <figcaption className="absolute bottom-0 left-0 p-5 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="font-serif-display text-white text-xl">{g.title}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
